// Login. Google only, no signup path (D11/D29, 05 §2). A stranger who reaches this page and
// signs in with Google is rejected by the database trigger, and gets told so plainly rather
// than being dropped into an empty app.

import { useState } from 'react';
import { signInWithGoogle } from './useSession.js';
import './login.css';

/**
 * Supabase sends a rejected sign-in back here with `error` / `error_description` in the URL
 * fragment (the allowlist trigger raises inside the auth flow). Nothing read them before, so
 * a stranger simply saw the login page again.
 */
function rejectionFromUrl(): string | null {
  if (typeof window === 'undefined') return null;
  const raw = `${window.location.hash.replace(/^#/, '')}&${window.location.search.replace(/^\?/, '')}`;
  const params = new URLSearchParams(raw);
  const description = params.get('error_description');
  if (description !== null && description !== '') return description.replace(/\+/g, ' ');
  return params.get('error') === null ? null : 'Този профил няма достъп.';
}

export function LoginPage({ rejected }: { rejected?: boolean }) {
  const [busy, setBusy] = useState(false);
  const rejection = rejected === true ? 'Този профил няма достъп.' : rejectionFromUrl();

  const handleSignIn = async (): Promise<void> => {
    setBusy(true);
    try {
      await signInWithGoogle();
    } catch {
      setBusy(false);
    }
  };

  return (
    <main className="login">
      <div className="login__card">
        <h1 className="login__title">LeadG</h1>
        <p className="login__sub">Вход само с Google</p>

        {rejection !== null && (
          <p className="login__error" role="alert">
            {rejection} Влезте с одобрен акаунт.
          </p>
        )}

        <button className="login__button" onClick={() => void handleSignIn()} disabled={busy}>
          {busy ? 'Пренасочване…' : 'Вход с Google'}
        </button>
      </div>
    </main>
  );
}
